import styled from '@emotion/styled';
import { Link } from 'ds/components/link';
import { SmallText, TextLabel } from 'ds/components/typography';

export const Column = styled(SmallText)`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const MobileDateColumn = styled.div`
  position: relative;
  margin-left: -100%;
  width: 200%;
`;

export const MobilePriceColumn = styled.div`
  display: none;
`;

export const DatePriceRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const MainMobileInfo = styled(SmallText)`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
`;

export const SecondaryMobileInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0 8px;
  margin-top: 8px;
`;

export const MobileAddress = styled(Link)``;

export const ListingInfo = styled(SmallText)`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  :before {
    content: '•';
    margin-left: ${({ theme }) => theme.spacing(1)};
    margin-right: ${({ theme }) => theme.spacing(1)};
  }
`;

export const ListingAgentInfo = styled(TextLabel)`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  border-radius: ${({ theme }) => theme.borderRadius.tiny};
  padding: ${({ theme }) => `${theme.spacing(0.25)} ${theme.spacing(0.5)}`};
  background-color: ${({ theme }) => theme.colors.neutrals.grey8};
  max-width: 140px;
  margin-right: auto;
  display: flex;
  align-items: center;
  > div {
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;

export const EmptyResults = styled(SmallText)`
  padding-top: ${({ theme }) => theme.spacing(3)};
  padding-bottom: ${({ theme }) => theme.spacing(3)};
  text-align: center;
`;
